import { RemoteError } from '@bsync/sync-engine';

interface PgLikeError {
  message?: string;
  code?: string;
  status?: number;
  details?: string;
  hint?: string;
}

/** Translate supabase-js / PostgREST errors into the engine's error taxonomy. */
export function toRemoteError(err: unknown, status?: number): RemoteError {
  if (err instanceof RemoteError) return err;
  const e = (err ?? {}) as PgLikeError;
  const message = e.message ?? String(err);
  if (/device_revoked/.test(message)) return new RemoteError('device_revoked', 'device_revoked', err);
  if (/clock_skew/.test(message)) return new RemoteError('clock_skew', 'clock_skew', err);
  if (/not_authenticated|JWT|jwt|PGRST30[0-3]/.test(message) || e.code === 'PGRST301' || e.code === '28000' || status === 401) {
    return new RemoteError('unauthorized', message, err);
  }
  if (status === 429) return new RemoteError('rate_limited', message, err);
  if (status === 0 || /Failed to fetch|NetworkError|network|fetch failed|Load failed|ECONN|ETIMEDOUT/i.test(message)) {
    return new RemoteError('offline', message, err);
  }
  return new RemoteError('server', message, err);
}
